import React from 'react';
import MobileAdhesionGak from './gak/MobileAdhesion';
const MobileAdhesion = ({ safety ='off'  })=>{
    return /*#__PURE__*/ React.createElement(MobileAdhesionGak, {
        safety: safety
    });
};
MobileAdhesion.displayName = 'MobileAdhesion';
export default MobileAdhesion;
